import React from 'react'

export function Toast({ toast }) {
  if (!toast) return null
  return (
    <div
      className={`toast toast--${toast.type}`}
      role={toast.type === 'err' ? 'alert' : 'status'}
      aria-live="polite"
    >
      {toast.msg}
    </div>
  )
}
